import "core-js/actual";
import intlTelInput from 'intl-tel-input';
import intlTelInputUtils from 'intl-tel-input/build/js/utils';

const isContactsSupported =
    "contacts" in navigator && "ContactsManager" in window;
const ctxModal = new bootstrap.Modal(document.getElementById('showConfirmTxModal'));

let productButtons = document.querySelectorAll('.product[data-product]');
productButtons.forEach(button => {
    button.addEventListener('click', () => {
        // console.log(button);
        showProductsModal(button);
    });
});
let ctxForm = document.getElementById('ctx-form');
let pinInput = document.getElementById("ctx-field-pin");
let emailInput = document.getElementById("ctx-field-email");

let isGuest = function () {
    return !pinInput && !!emailInput;
}

let guestOrDashboardPath = function () {
    return isGuest()? 'g' : 'dashboard';
};

function loading_screen() {
    displayAlert(`
<div class="text-center">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
    `, 'secondary', 0);
}
// Initialize intlTelInput
const hiddenFieldPhoneNumber = document.getElementById("ctx-hidden-field-phone_number");

const hiddenIti = intlTelInput(hiddenFieldPhoneNumber, {
    initialCountry: "ng",
    onlyCountries: ["ng"],
    allowDropdown: false,
    showFlags: false,
    nationalMode: true,
    utilsScript: intlTelInputUtils,
});

ctxForm.addEventListener('submit', async (event) => {
    // console.log(event);
    event.preventDefault();
    event.target.disabled = true;
    if (event.submitter) event.submitter.disabled = true;
    loading_screen();
    let purchaseScheduleOption = 0;
    let product = JSON.parse(ctxForm.dataset.product);
    let req_fields = JSON.parse(ctxForm.dataset.fields);

    let other_fields = [
        "_token",
    ];

    if (isGuest()){
        other_fields.push("email");
    } else {
        other_fields.push("schedule", "pin");
    }

    // Create an object from the FormData
    const data = {'parameters': {}};
    req_fields.forEach((key) => {
        // console.log( key);
        data['parameters'][key] = document.getElementById('ctx-field-' + key)?.value;
    });
    other_fields.forEach((key) => {
        // console.log( key);
        data[key] = document.getElementById('ctx-field-' + key)?.value;
    });

    data["payment_method"] = document.querySelector(
        "[name=ctx-field-payment-method]:checked"
    )?.value;

    if (!isGuest() && data["schedule"]){
        try {
            data["schedule"] = JSON.parse(data["schedule"]);
            purchaseScheduleOption = document.querySelector(
                "[name=ctx-field-schedule-option]:checked"
            )?.value??1;
            data["schedule-option"] = purchaseScheduleOption;
        } catch (error) {
            console.error(error);
            data["schedule"] = null;
        }
    } else {
        data["schedule"] = null;
    }
        // Send POST request
        try {
            console.debug(data);

            const response = await fetch(`/${guestOrDashboardPath()}/purchase/${product.id}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(data),
                }
            );
            let responseData = await response.json();
            let msg = `
        <h5 class="alert-title  text-uppercase">${responseData.status}</h5>
        <div class="alert-body">${responseData.message}</div>
        `;
            if (response.ok) {
                let tx = responseData.data;
                if (tx && (!!tx.wallet_balance || tx.wallet_balance === 0)) {
                    window.setWalletBalance(tx.wallet_balance);
                    selectPaymentMethod(product.amount_in_naira);
                }

                if (tx && !!tx.payment_url) {
                    let msg2 = `
            <h5 class="alert-title text-uppercase ">Loading payment page</h5>
            <div class="alert-body text-center">
            <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
            </div>
            <br>
            <p>If this is taking too long, <a href="${tx.payment_url}" >click here</a></p>
            </div>
            `;
                    displayAlert(msg2, "success", 0);

                    window.location.href = tx.payment_url;
                    // window.close();
                    event.target.disabled = false;
                    if (event.submitter) event.submitter.disabled = false;
                    return;
                } else if (tx) {
                    msg = `
        <h5 class="alert-title  text-uppercase"><i class="${tx.status_icon}"></i> ${responseData.status}</h5>
        <div class="alert-body p-2">
        ${tx.message}
        <br>
        <a class="btn btn-primary text-end" href="/${guestOrDashboardPath()}/transactions/${tx.ref}">
        View details
       </a>
        </div>
        `;
                    let alertClass = tx.status_color ? tx.status_color : "info";
                    if (tx.status == 2) {
                        ctxModal.hide();
                        displayAlert(msg, alertClass, 60000, "#header");
                    } else {
                        displayAlert(msg, alertClass, 60000);
                    }

                    event.target.disabled = false;
                    if (event.submitter) event.submitter.disabled = false;

                    return;
                }
            }

            event.target.disabled = false;
            if (event.submitter) event.submitter.disabled = false;
            displayAlert(msg, "danger", 10000);
        } catch (error) {
            console.error("Error:", error);

            event.target.disabled = false;
            if (event.submitter) event.submitter.disabled = false;
            displayAlert(
                "An error occurred. Please try again later.",
                "danger",
                5000
            );
        }

});

function showProductsModal(button) {
    if (!!pinInput) {
        pinInput.value = "";
    }
    // Get the data attributes from the button
    let product = JSON.parse(button.dataset.product);
    let req_fields =  !!product.ctx_fields? Object.keys(product.ctx_fields) : JSON.parse(button.dataset.fields);
    console.debug(product, req_fields);
    ctxForm.setAttribute('data-product', button.dataset.product);
    ctxForm.setAttribute('data-fields', JSON.stringify(req_fields));
    product['amount_due'] = product.amount_in_naira.toLocaleString();
    product['amount_in_naira'] = product.amount_in_naira.toLocaleString();
    // Iterate through object properties
    for (let prop in product) {
        if (product.hasOwnProperty(prop)) {
            // Try to find an element with matching ID
            let element = document.getElementById("ctx-product-" + prop);

            if (element) {
                if (product[prop]) {
                    // Replace the inner text with the value from the object
                    element.innerText = product[prop];
                    element.parentElement.hidden = false;
                } else {
                    element.parentElement.hidden = true;
                }
            }
        }
    }


    // Append the row to the element with ID 'ctx-fields'
    var ctxFields = document.getElementById('ctx-fields');


    if (ctxFields) {
        ctxFields.innerHTML = ''; // Clear the content
        if (req_fields.includes('phone_number')) {
            ctxFields.appendChild(phone_input());
            let element = document.getElementById('ctx-field-phone_number');

            // intlTelInput(element, {
            //     // any initialisation options go here
            //     hiddenInput: element.dataset.name,
            //     initialCountry: 'ng',
            //     onlyCountries: ['ng'],
            //     placeholderNumberType: 'MOBILE',
            //     intlTelInputUtils: intlTelInputUtils
            // });
        }
        if (req_fields.includes('quantity')) {
            ctxFields.appendChild(quantity_input());
        }
        let unit_priceElement = document.getElementById('ctx-product-amount_in_naira');
        if (req_fields.includes('amount')) {
            unit_priceElement.parentElement.parentElement.hidden = true;
            ctxFields.appendChild(amount_input(product.percent_discount ?? 0));
        } else {
            unit_priceElement.parentElement.parentElement.hidden = false;
        }
        if (req_fields.includes('smart_card_number')) {
            ctxFields.appendChild(smart_card_input());
        }
        if (req_fields.includes('meter_number')) {
            ctxFields.appendChild(meter_number_input());
        }
    }


    ctxModal.show();

    selectPaymentMethod(product.amount_in_naira);
}

function meter_number_input() {
    // Create elements
    var divRow = document.createElement('div');
    divRow.className = 'row mb-3';

    var label = document.createElement('label');
    label.className = 'col-md-4 col-form-label text-md-end text-body';
    label.setAttribute('for', 'ctx-field-meter_number');
    label.innerText = 'Meter Number';


    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'form-control';
    input.id = 'ctx-field-meter_number';
    input.setAttribute('name', 'meter_number');
    input.setAttribute('placeholder', 'enter meter number');
    input.setAttribute('autocomplete', 'off');
    input.required = true;

    // Add change event listener
    input.addEventListener('change', function () {
        let mNumber = document.getElementById('ctx-field-meter_number').value;
        if (mNumber.toString().length >= 13) {
            confirm_meter_number();
        }
    });

    // Create button
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn-success';
    button.innerText = 'Verify';

    // Add onclick event
    button.addEventListener('click', confirm_meter_number);


    let divCol = document.createElement('div');
    let divInputGroup = document.createElement('div');
    divCol.className = 'col-md-7';
    divInputGroup.className = 'input-group';

    // Append elements
    divInputGroup.appendChild(input);
    divInputGroup.appendChild(button);
    divRow.appendChild(label);
    divCol.appendChild(divInputGroup);
    divRow.appendChild(divCol);
    return divRow;
}

function smart_card_input() {
    // Create elements
    var divRow = document.createElement('div');
    divRow.className = 'row mb-3';

    var label = document.createElement('label');
    label.className = 'col-md-4 col-form-label text-md-end text-body';
    label.setAttribute('for', 'ctx-field-smart_card_number');
    label.innerText = 'Smart Card or IUC Number';



    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'form-control';
    input.id = 'ctx-field-smart_card_number';
    input.setAttribute('name', 'smart_card_number');
    input.setAttribute('placeholder', 'enter smart card or iuc number');
    input.setAttribute('autocomplete', 'off');
    input.required = true;

    // Add change event listener
    input.addEventListener('change', function () {
        let smartCardNumber = document.getElementById('ctx-field-smart_card_number').value;
        if (smartCardNumber.toString().length >= 10) {
            confirm_smart_card_number();
        }
    });

    // Create button
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'btn btn-success';
    button.innerText = 'Verify';

    // Add onclick event
    button.addEventListener('click', confirm_smart_card_number);

    let divCol = document.createElement('div');
    let divInputGroup = document.createElement('div');
    divCol.className = 'col-md-7';
    divInputGroup.className = 'input-group';

    // Append elements
    divInputGroup.appendChild(input);
    divInputGroup.appendChild(button);
    divRow.appendChild(label);
    divCol.appendChild(divInputGroup);
    divRow.appendChild(divCol);
    return divRow;
}

function confirm_smart_card_number() {

    let smartCardNumber = document.getElementById('ctx-field-smart_card_number').value;
    return confirm_utility_number(smartCardNumber);
}

function confirm_meter_number() {

    let Number = document.getElementById('ctx-field-meter_number').value;
    let product = JSON.parse(ctxForm.dataset.product)
    let amount = document.getElementById('ctx-field-amount').value;
    return confirm_utility_number(Number, product.id, amount);
}

async function confirm_utility_number(utility_no, product_id = null, amount = null) {
    // This function will be executed when the button is clicked
    let service_id = document.getElementById('ctx-field-service_id').value;
    let category_id = document.getElementById('ctx-field-category_id').value;
    let details_view = document.getElementById('ctx-details');
    const params = new URLSearchParams();
    if (product_id) {
        params.append('product_id', product_id);
    }
    if (amount) {
        params.append('amount', amount);
    }
    try {
        loading_screen();
        const response = await fetch(`/${guestOrDashboardPath()}/verify/${service_id}/categories/${category_id}/${utility_no}?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        });
        let responseData = await response.json();
        let msg = `
        <h5 class="alert-title  text-uppercase">${responseData.status}</h5>
        <div class="alert-body">${responseData.message ?? 'Invalid'}</div>
        `;
        if (response.ok) {
            let data1 = responseData.data;
            if (data1) {
                let details = `
        Name: ${data1.details.name} <br>`;
                if (data1.details.status) {
                    details += `
        Status: ${data1.details.subscription_status} <br>
        Current Plan: ${data1.details.current_plan} <br>
        Date Due: ${data1.details.due_date} <br>`;
                }
                if (data1.details.meter_type) {
                    details += `
        Meter Type: ${data1.details.meter_type} <br>
        Address: ${data1.details.address} <br>`;
                }
                msg = `
        <h5 class="alert-title  text-uppercase">${responseData.status}</h5>
        <div class="alert-body p-2">
        ${details}
        </div>
        `;
                document.getElementById('ctx-details').innerHTML = details;
                displayAlert(msg, 'success', 60000);

            }
        } else {
            displayAlert(msg, 'danger', 10000);
        }

    } catch (error) {
        console.error('Error:', error);
        displayAlert('An error occurred. Please try again later.', 'danger', 5000);
    }

    // Add your logic here to handle the confirmed smart card number
}

function quantity_input() {
    // Create elements
    var divRow = document.createElement('div');
    divRow.className = 'row mb-3';

    var label = document.createElement('label');
    label.className = 'col-md-4 col-form-label text-md-end text-body';
    label.setAttribute('for', 'ctx-field-quantity');
    label.innerText = 'Quantity';

    var divCol = document.createElement('div');
    divCol.className = 'col-md-7';

    var input = document.createElement('input');
    input.type = 'number';
    input.className = 'form-control';
    input.id = 'ctx-field-quantity';
    input.value = '1';
    input.setAttribute('name', 'quantity');
    input.setAttribute('placeholder', 'enter quantity');
    input.setAttribute('min', '1');
    input.required = false;

    // Add change event listener
    input.addEventListener('change', function (event) {
        // This function will be executed when the input value changes
        let newValue = event.target.value;
        let amount_due = document.getElementById('ctx-product-amount_due');
        let unit_priceElement = document.getElementById('ctx-product-amount_in_naira');

        // Get the unit price without formatting
        let unit_price = parseFloat(unit_priceElement.textContent.replace(/,/g, '')); // Remove commas

        // Calculate the new amount_due
        let newAmountDue = unit_price * newValue;

        // Format the newAmountDue with commas
        // Apply number formatting
        // Update the amount_due element with the formatted value
        amount_due.textContent = newAmountDue.toLocaleString();

        console.log('New quantity value: ' + newValue);
    });

    // Append elements
    divCol.appendChild(input);
    divRow.appendChild(label);
    divRow.appendChild(divCol);
    return divRow;
}

function amount_input(discount = 0) {
    // Create elements
    let divRow = document.createElement('div');
    divRow.className = 'row mb-3';

    let label = document.createElement('label');
    label.className = 'col-md-4 col-form-label text-md-end text-body';
    label.setAttribute('for', 'ctx-field-amount');
    label.innerText = 'Amount';

    let divCol = document.createElement('div');
    divCol.className = 'col-md-7';

    let input = document.createElement('input');
    input.type = 'number';
    input.className = 'form-control';
    input.id = 'ctx-field-amount';
    input.setAttribute('name', 'amount');
    input.setAttribute('placeholder', 'enter amount');
    input.setAttribute('min', '50');
    input.setAttribute('step', '1');
    input.setAttribute('autocomplete', 'transaction-amount');
    input.required = true;

    // Add change event listener
    input.addEventListener('keyup', function (event) {
        // This function will be executed when the input value changes
        let newValue = Math.floor(event.target.value);
        let amount_due = document.getElementById('ctx-product-amount_due');

        // Calculate the new amount_due
        // Format the newAmountDue with commas
        // Apply number formatting
        // Update the amount_due element with the formatted value
        amount_due.textContent = roundUp((newValue - ((newValue / 100) * discount)), 2).toLocaleString();
        console.log('New amount value: ' + newValue);
        selectPaymentMethod(amount_due.textContent);
    });

    // Append elements
    divCol.appendChild(input);
    divRow.appendChild(label);
    divRow.appendChild(divCol);
    return divRow;
}
//     let payment_method = document.querySelector(
// "[name=ctx-field-payment-method]:checked")?.value;
//
// a function that takes in a number (float)
// and selects the right payment_method based on the following
// 1. If wallet balance is greater than or equal to the amount use wallet
// 2. if wallet balance is less than the amount and balance is the selected payment_method,
//    select the first payment method that is not balance and is enabled
function selectPaymentMethod(amount) {

    console.debug("Amount:", amount);
    let walletBalance = window.getWalletBalance();
    console.debug("Wallet Balance:", walletBalance);

    // Return if wallet balance is not set
    if (!walletBalance && walletBalance !== 0) {
        console.debug("Wallet balance is not set.");
        return;
    }

    // parse amount and walletBalance to float
    amount = (!isNaN(amount)) ? amount : parseFloat(amount.toString().replace(/,/g, ''));
    walletBalance = parseFloat(walletBalance);

    let selectedPaymentMethod = document.querySelector(
        "[name=ctx-field-payment-method]:checked"
    )?.value;
    console.debug("Selected Payment Method:", selectedPaymentMethod);

    // Do nothing if wallet balance is sufficient
    if (walletBalance >= amount && selectedPaymentMethod !== "wallet") {
        console.debug("Wallet balance is sufficient.");
        let paymentMethods = document.querySelectorAll(
            "[name=ctx-field-payment-method]"
        );
        for (let method of paymentMethods) {
            if (method.value === "wallet" && !method.disabled) {
                method.checked = true;
                console.debug("Switching to payment method:", method.value);
                break;
            }
        }
        return;
    }

    // If wallet balance is insufficient and 'wallet' is the selected payment method
    if (walletBalance < amount && selectedPaymentMethod === "wallet") {
        console.debug("Wallet balance is not sufficient.");
        let paymentMethods = document.querySelectorAll(
            "[name=ctx-field-payment-method]"
        );
        for (let method of paymentMethods) {
            if (method.value !== "wallet" && !method.disabled) {
                method.checked = true;
                console.debug("Switching to payment method:", method.value);
                break;
            }
        }
    }
}

function roundUp(num, precision) {
    precision = Math.pow(10, precision);
    return Math.ceil(num * precision) / precision;
}

async function selectContact() {
    if (isContactsSupported) {
        let input = document.getElementById('ctx-field-phone_number');
        let customer_name  = document.getElementById('ctx-label-name');
        if(customer_name){customer_name.innerText = '';}
        input.value = '';
        let contacts = await navigator.contacts.select(['name', 'tel'], {multiple: false});
console.log(contacts);
        if (!contacts.length) {
            // no contacts were selected.
            return;
        }


        if (input) {
            // Check if there are multiple phone numbers

            if (contacts[0].tel.length > 1) {
                // Display a Bootstrap modal with radio buttons for phone number selection
                showModalForPhoneNumberSelection(contacts[0].tel, input);
            } else {
                // Set the first phone number if there's only one
                input.value = contacts[0].tel[0];
            }
            if (customer_name){
            customer_name.innerText = `(${contacts[0].name[0]??''})`;}
        }
    } else {
        console.log('Contacts not supported');
    }
    // return contacts;
}

function showModalForPhoneNumberSelection(phoneNumbers, input) {
    // Convert CSV string to array if phoneNumbers is a string
    if (typeof phoneNumbers === 'string') {
        phoneNumbers = phoneNumbers.split(',');
        input.value = phoneNumbers.pop();
    }

    // Create a Bootstrap modal
    let modal = new bootstrap.Offcanvas(document.getElementById('phoneNumberModal'));

    // Get the modal content element
    let modalContent = document.getElementById('phoneNumberModalContent');

    // Clear previous content
    modalContent.innerHTML = '';

    // Add radio buttons for each phone number
    phoneNumbers.forEach((number, index) => {

        // 1. Create the main container element
        let formCheckDiv = document.createElement('div');
        formCheckDiv.classList.add('form-check');

        // 2. Create the radio input element
        let radioInput = document.createElement('input');
        radioInput.type = 'radio';
        radioInput.name = 'phoneNumberRadio';
        radioInput.value = number.trim(); // Trim to handle potential spaces
        radioInput.id = 'phoneNumberRadio' + index;
        radioInput.classList.add('form-check-input');
        let handler = function () {
            // Find the selected radio button
            let selectedRadio = modalContent.querySelector('input[name="phoneNumberRadio"]:checked');

            if (selectedRadio) {
                // Set the selected phone number in the input field
                input.value = selectedRadio.value;
                // Close the modal
                modal.hide();
            } else {
                alert('Please select a phone number.');
            }
        };
        radioInput.addEventListener('click', handler);
        radioInput.addEventListener('change', handler);
// 3. Create the label element
        let label = document.createElement('label');
        label.classList.add('form-check-label');
        label.htmlFor = 'phoneNumberRadio' + index; // Connect label to the radio input
        label.innerText = number.trim(); // Trim to handle potential spaces

// 4. Append the input and label to the container
        formCheckDiv.appendChild(radioInput);
        formCheckDiv.appendChild(label);

// 5. Add the container to the desired location in the DOM
        modalContent.appendChild(formCheckDiv);
        // modalContent.appendChild(document.createElement('br'));
    });


    // Show the modal
    modal.show();
}


function phone_input() {
    // Create elements
    let divRow = document.createElement('div');
    divRow.className = 'row mb-3';

    let label = document.createElement('label');
    label.className = 'col-md-4 col-form-label text-md-end text-body';
    label.setAttribute('for', 'ctx-field-phone_number');
    label.innerHTML = 'Phone Number <span class="text-muted" id="ctx-label-name"></span>';

    let divCol = document.createElement('div');
    let divInputGroup = document.createElement('div');
    divCol.className = 'col-md-7';
    divInputGroup.className = 'input-group';

    let input = document.createElement('input');
    input.type = 'tel';
    input.className = 'form-control tel-input';
    input.id = 'ctx-field-phone_number';
    input.setAttribute('data-name', 'phone_number');
    input.setAttribute('placeholder', '+234xxxxxxxxxx');
    input.setAttribute('autocomplete', 'tel');
    input.setAttribute('autofocus', 'autofocus');
    input.required = true;

    let hint = document.createElement('span');
    hint.className = 'input-group-text';
    hint.id = 'phone-network-hint';
    hint.innerText = "🇳🇬";

    const updateNetworkHint = () => {
        let value = input.value;
        let network = getNetworkHint(value);
        hint.innerText = network ? network : "❌";

        if (isValidNumber(value)) {
            input.classList.remove('is-invalid');
            input.classList.add('is-valid');
        } else {
            input.classList.remove('is-valid');
            input.classList.add('is-invalid');

            if (value.length >= 10) {
                    hint.innerText = "⚠️";
            }
        }

    };

    input.addEventListener('keyup', updateNetworkHint);
    input.addEventListener('change', updateNetworkHint);
    // input.addEventListener('focusout', updateNetworkHint);
    input.addEventListener("focus", updateNetworkHint);
    input.addEventListener("input", updateNetworkHint);

    divInputGroup.appendChild(hint);
    divInputGroup.appendChild(input);

    try {
        if (isContactsSupported) {
            (navigator.contacts.getProperties()).then(function (supportedProperties) {
                if (supportedProperties.includes("tel")) {
                    let button = document.createElement('button');
                    button.type = 'button';
                    button.className = 'btn btn-secondary btn-sm';
                    button.innerText = 'Select Contact';
                    button.onclick = selectContact;
                    divInputGroup.appendChild(button);
                }
            });
        }
    } catch (e) {
        console.log(e);
    }

    divCol.appendChild(divInputGroup);
    divRow.appendChild(label);
    divRow.appendChild(divCol);
    return divRow;
}

function isValidNumber(phoneNumber) {


    // Set the phone number to the input
    hiddenIti.setNumber(phoneNumber);

    return hiddenIti.isValidNumber();
}

function getNetworkHint(phoneNumber) {


    // Set the phone number to the input
    hiddenIti.setNumber(phoneNumber);

    // if (!hiddenIti.isValidNumber()){
    //     return '';
    // }

    // Get the cleaned number
    const cleanedNumber = hiddenIti.getNumber(/*intlTelInput.utils.numberFormat.NATIONAL*/2);

    console.log(phoneNumber + " becomes -> " + cleanedNumber);
    const networkPrefixes = {
        'MTN': ['0803', '0806', '0703', '0706', '0810', '0813', '0814', '0816', '0903', '0906'],
        'Glo': ['0805', '0807', '0705', '0811', '0815', '0905', '0915'],
        'Airtel': ['0802', '0808', '0708', '0812', '0902', '0907', '0901'],
        '9mobile': ['0809', '0817', '0818', '0908', '0909'],
        'Starcomms' : ['07028', '07029', '0819'],
        'Visafone' : ['07025', '07026', '0704'],
        'Multilinks' : ['07027', '0709'],
        'Zoom' : ['0707'],
        'ntel' : ['0804'],
        'Smile' : ['0702'],
    };

    for (let network in networkPrefixes) {
        if (networkPrefixes[network].some(prefix => cleanedNumber.startsWith(prefix))) {
            return network;
        }
    }
    return '';
}

function displayAlert(message, type = "info", duration = 5000, attachTo = '#ctx-fields') {
    // Create alert element
    let dismissible = duration > 0;
    var alertDiv = document.createElement('div');
    alertDiv.className = 'ctx-alert shadow-sm alert alert-' + type + (dismissible ? " alert-dismissible" : "") + ' fade show position-fixed top-25 z-3 start-50 translate-middle-x';
    alertDiv.role = 'alert';

    // Create close button if alert is dismissible
    if (dismissible) {
        alertDiv.innerHTML = `
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            <div class="p-2">
                ${message}
            </div>
        `;
    } else {
        alertDiv.innerHTML = `
            <div class="p-2">
                ${message}
            </div>
        `;
    }

    let previousAlerts = document.querySelectorAll('.ctx-alert');
    previousAlerts.forEach(alert => alert.remove());
    // Append alert after ctx-fields
    var ctxFields = document.querySelector(attachTo);
    if (ctxFields) {
        ctxFields.parentNode.insertBefore(alertDiv, ctxFields.nextSibling);
    }

    if (dismissible) {
        // Set timeout to remove the alert after a duration
        setTimeout(function () {
            alertDiv.remove();
        }, duration);
    }
}


let fundButtons = document.querySelectorAll('.fund-with[data-gateway]');
fundButtons.forEach(button => {
    button.addEventListener('click', () => {
        // console.log(button);
        showFundWithModal(button);
    });
});
let fundWithForm = document.getElementById('fund-with-form');
let fundWithGatewayName = document.getElementById('fund_with_gateway_name');

function showFundWithModal(button) {

    // Get the data attributes from the button
    let gateway = button.dataset.gateway;
    console.debug(gateway);
    fundWithGatewayName.innerHTML = gateway;
    fundWithForm.setAttribute('data-gateway', button.dataset.gateway);
    const modal = new bootstrap.Modal(document.getElementById('showFundWithModal'));
    modal.show();
}

fundWithForm.addEventListener('submit', async (event) => {
    // console.log(event);
    event.preventDefault();
    event.target.disabled = true;
    if (event.submitter) event.submitter.disabled = true;
    displayAlert(`
<div class="text-center">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
    `, 'secondary', 0, '#fund-with-form');

    let gateway = fundWithForm.dataset.gateway;

    let other_fields = ['amount', '_token'];


    // Create an object from the FormData
    let data = {};
    other_fields.forEach((key) => {
        // console.log( key);
        data[key] = document.getElementById('fund-with-field-' + key)?.value;
    });

    // Send POST request
    try {
        const response = await fetch(`/dashboard/fund_with/${gateway}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(data)
        });
        const responseData = await response.json();

        if (response.ok) {
            let msg2 = `
            <h5 class="alert-title text-uppercase ">Loading payment page</h5>
            <div class="alert-body text-center">
            <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
            </div>
            <br>
            <p>If this is taking too long, <a href="${responseData.payment_url}" >click here</a></p>
            </div>
            `;
            displayAlert(msg2, 'success', 0, '#fund-with-form');
            let modal = new bootstrap.Modal(document.getElementById('showFundWithModal'));
            modal.hide();
            window.location.href = responseData.data.payment_url;
            // window.close();
        } else {
            let msg = `
        <h5 class="alert-title text-uppercase ">${responseData.status}</h5>
        <div class="alert-body">${responseData.message}</div>
        `;
            displayAlert(msg, 'danger', 5000, '#fund-with-form');
        }
        event.target.disabled = false;
        if (event.submitter) event.submitter.disabled = false;
    } catch (error) {
        console.error('Error:', error);
        displayAlert('An error occurred. Please try again later.', 'danger', 5000, '#fund-with-form');

        event.target.disabled = false;
        if (event.submitter) event.submitter.disabled = false;
    }
});
